import { useRef } from 'react';

export function useIndexedLabels() {
  const labelVisibility = useRef(new Map());
  const labelIndexList = useRef([]);

  const getTitleIndex = (text, label, visible = true) => {
    labelVisibility.current.set(label, { text, visible });

    labelIndexList.current = Array.from(labelVisibility.current.entries())
      .filter(([, info]) => info.visible)
      .map(([key, info], idx) => ({
        label: key,
        text: info.text,
        index: idx + 1,
      }));

    const item = labelIndexList.current.find(i => i.label === label);
    return item ? `${item.index} - ${item.text}` : null;
  };

  const getIndexByLabel = (label) => {
    const item = labelIndexList.current.find(i => i.label === label);
    return item?.index ?? null;
  };

  const resetIndexList = () => {
    labelVisibility.current.clear();
    labelIndexList.current = [];
  };

  return {
    getTitleIndex,
    getIndexByLabel,
    resetIndexList,
  };
}
